import { render, staticRenderFns } from "./Gamify.vue?vue&type=template&id=51601e52&scoped=true&"
import script from "./Gamify.vue?vue&type=script&defer=true&lang=js&"
export * from "./Gamify.vue?vue&type=script&defer=true&lang=js&"
import style0 from "./Gamify.vue?vue&type=style&index=0&id=51601e52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51601e52",
  null
  
)

export default component.exports